import React, { useState, useContext, SyntheticEvent, useEffect } from "react";
import { useTranslation } from "react-i18next";

//MUI
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

//Custom
import OperationsContext from "@/components/OperationsContext/OperationsContext";

//Types
import { PickerItem } from "@/@types/controls/controls";
import { AutocompleteChangeReason } from "@mui/material";
import { OperationsContextType } from "@/components/OperationsContext/OperationsContext";

export type QualityControlPickerProps = {
  items: Array<PickerItem>;
  selectedItem: PickerItem | null;
  onChange: (id: number | null) => void;
};

const QualityControlPicker = (props: QualityControlPickerProps) => {
  const [isLoading, setIsLoading] = useState(true);

  const { t } = useTranslation();

  const { items, selectedItem, onChange } = props;

  const label = "qc.picker_helper";
  const loadingText = "operations.loading";

  const handleChange = (
    evt: SyntheticEvent,
    value: PickerItem | null,
    reason: AutocompleteChangeReason
  ) => {
    switch (reason) {
      case "createOption":
        break;
      case "selectOption":
        applyChange(value);
        break;
      case "removeOption":
        break;
      case "clear":
        applyChange(null);
        break;
      case "blur":
        break;
    }
  };

  const applyChange = (option: PickerItem | null) => {
    if (option) {
      onChange(option.value as number);
    } else {
      onChange(null);
    }
  };

  useEffect(() => {
    if (items.length) {
      setIsLoading(false);
    }
  }, [items]);

  return (
    <Autocomplete
      disablePortal
      size="small"
      options={items}
      value={selectedItem}
      getOptionLabel={(option: PickerItem) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            placeholder={t(label)}
            variant="outlined"
            required={false}
            label={undefined}
            sx={{ ml: 2, minWidth: 400, maxWidth: 600 }}
          />
        );
      }}
      autoSelect={true}
      onChange={handleChange}
      loading={isLoading}
      loadingText={t(loadingText)}
      autoHighlight
    />
  );
};

export default QualityControlPicker;
